import React, { Fragment, useState, useContext } from "react";
import { TextsContext } from '../context/textsContext';
import { Icon } from "@iconify/react";
import { useCotizador } from "../context/apiContext";
import ValidaComponent from "./ValidaComponent";
import styleForm from '../scss/form.module.scss';
import { sendEmailWithPdf } from "../api/emailApi";
import { usePdf } from "../hooks/PdfHook";
import { downloadPdfWithData } from "../api/pdfGeneratorApi";
import DialogComponent from "./DialogComponent";
import { TitleH2Component } from "./TitleH2Component";
import { ParagraphComponent } from "./ParagraphComponent";
import { saveCotizador } from "api/cotizadorApi";
import { useCotizacionSaveAdapter } from "../hooks/CotizadorSaveAdapterHook";
import { useAuth } from "../context/userContext";

const ModalEnvioEmailComponent = () => {
    const { texts } = useContext(TextsContext);
    const { show, setShow } = useCotizador();
    const [showConfirmar, setShowConfirmar] = useState(false);
    const [to, setTo] = useState("");
    const [sending, setSending] = useState(false);
    const [showemail, setShowemail] = useState(false);
    const [loadingPdf, setLoadingPdf] = useState(false);
    const { user } = useAuth();
    const handleClose = () => setShow(false);
    const handleCloseConfirmar = () => setShowConfirmar(false);
    const handleCloseemail = () => setShowemail(false);

    const { getPdfData, getPdfRefactorData } = usePdf();
    const { createApplicationSave } = useCotizacionSaveAdapter();

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const handlePdf = () => {
        setLoadingPdf(true);
        saveCotizador(getPdfData())
            .then(({ data }) => {
                return createApplicationSave(data.id)
            }).then(() => {
                return downloadPdfWithData(getPdfRefactorData());
            }).then(() => {
                setShowConfirmar(true);
                setShow(false);
            }).catch(() => {
                console.error("handlePdf error");
            }).finally(() => {
                setLoadingPdf(false);
            });
    }

    const handleSend = () => {
        if (!validateEmail(to)) {
            return;
        }
        setSending(true);
        sendEmailWithPdf({ ...getPdfRefactorData(), to }, user).then(() => {
            setShowConfirmar(true);
            setSending(false);
            setShowemail(false);
            handleClose();
        }).catch((e) => {
            console.error(e);
            setSending(false);
        })
    }

    return (
        <Fragment>

            {/* Guardar / descargar */}
            <DialogComponent
                show={show}
                onClose={handleClose}
                onConfirm={handlePdf}
                confirmLoading={loadingPdf}
                confirmText={
                    <span className="d-flex justify-content-center align-items-center">
                        <span className="me-2 d-flex"><Icon icon="prime:file-pdf" width={20} height={20} /></span>
                        <span>{texts?.modal_button_quote ?? 'Download'}</span>
                    </span>
                }
            >
                <TitleH2Component styleGroup="raleway fw_700 color_primary mb-0">
                    {texts?.modal_pdf_save ?? 'Save'}
                </TitleH2Component>
            </DialogComponent>

            {/* Confirmación de descarga */}
            <DialogComponent
                show={showConfirmar}
                onClose={handleCloseConfirmar}
                onConfirm={handleCloseConfirmar}
                confirmText={texts?.modal_boton_closed ?? 'Closed'}
            >
                <Icon icon="mdi:check-circle-outline" width={40} height={40} style={{ color: '#61A60E' }} className="mb-3" />
                <ParagraphComponent styleGroup="raleway color_primary mb-0">
                    {texts?.modal_successful_message ?? 'The document has been downloaded correctly'}
                </ParagraphComponent>
            </DialogComponent>

            {/* Envío por email */}
            <DialogComponent
                show={showemail}
                onClose={handleCloseemail}
                onCancel={() => { setShowemail(false); setShow(true); }}
                onConfirm={handleSend}
                confirmLoading={sending}
                confirmDisabled={sending}
                cancelDisabled={sending}
                cancelText={texts?.modal_button_cancel ?? 'Cancel'}
                confirmText={texts?.modal_button_send ?? 'Send'}
            >
                <div className="d-flex align-items-center justify-content-center mb-3">
                    <TitleH2Component styleGroup="raleway fw_700 color_primary_2 mb-0 me-2">
                        {texts?.modal_form_field_quote ?? 'Send quote'}
                    </TitleH2Component>
                    <Icon icon="icon-park-outline:send-email" width={24} height={24} className="color_primary_2" />
                </div>
                <div className="w-100">
                    <input
                        type="email"
                        value={to}
                        onChange={(e) => { setTo(e.target.value) }}
                        className={`${styleForm.input_with_linemodal} w-100`}
                        placeholder={texts?.step1_form_placeholder_email ?? 'Email'}
                        name={"email"}
                    />
                    <ValidaComponent />
                </div>
            </DialogComponent>

        </Fragment>
    )
}
export default ModalEnvioEmailComponent;
